import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask w-full h-full"
}
const _hoisted_2 = { class: "modal-container-form" }
const _hoisted_3 = { class: "modal-body mtop-10" }
const _hoisted_4 = { class: "row w-full mtop-10" }
const _hoisted_5 = { class: "col-0-8 colend mright-04" }
const _hoisted_6 = { class: "main-m" }
const _hoisted_7 = { class: "row w-full mtop-08" }
const _hoisted_8 = { class: "col-0-8 colend mright-04" }
const _hoisted_9 = { class: "main-m" }
const _hoisted_10 = {
  key: 0,
  class: "w-full"
}
const _hoisted_11 = { class: "row w-full mtop-10" }
const _hoisted_12 = { class: "col-0-8 colend mright-04" }
const _hoisted_13 = { class: "main-m font-m" }
const _hoisted_14 = { class: "row w-full mtop-10" }
const _hoisted_15 = { class: "col-0-8 colend mright-04" }
const _hoisted_16 = { class: "main-m font-m" }

import { computed, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { AddOrUpdateFinancialChannelRequest } from '@/apiGenerate/medserver';
import { FinancialChannelType } from '@/models/accounting.model';
import InputText from 'primevue/inputtext';
import Select from 'primevue/select';


export default /*@__PURE__*/_defineComponent({
  __name: 'esFinancialChannelForm',
  props: {
    isOpen: { type: Boolean },
    header: {},
    confirmMethod: { type: Function }
  },
  emits: ["modal-close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;
const { t } = useI18n();
const channelTypes = ref<string[]>(Object.values(FinancialChannelType) as string[]);

const addOrUpdateFinancialChannelRequest = ref<AddOrUpdateFinancialChannelRequest>({
  title: undefined,
  type: undefined,
  bankAccounts: undefined,
  permissions: []
});

const confirmDisabled = computed(() => {
    return FinancialChannelType.BankAccount === addOrUpdateFinancialChannelRequest.value.type && 
        (!addOrUpdateFinancialChannelRequest.value.bankAccounts || !addOrUpdateFinancialChannelRequest.value.bankAccounts.iban || !addOrUpdateFinancialChannelRequest.value.bankAccounts.bic);
});

const confirmFormModal = async () => {
  try {
    await props.confirmMethod(addOrUpdateFinancialChannelRequest.value);
  } catch {
    throw t('error.DEFAULT');
  }
}

const closeFormModal = () => {
    emit('modal-close');
}

watch(
    () => props.isOpen,
  () => {
    addOrUpdateFinancialChannelRequest.value = {
        title: undefined,
        type: undefined,
        bankAccounts: undefined
    }
  }
);

watch(
    () => addOrUpdateFinancialChannelRequest.value.type,
  () => {
    if (FinancialChannelType.BankAccount === addOrUpdateFinancialChannelRequest.value.type) {
        addOrUpdateFinancialChannelRequest.value.bankAccounts = {
            iban: undefined,
            bic: undefined,
            id: undefined,
            active: true,
            editable: true
        }
    }
  }
);


return (_ctx: any,_cache: any) => {
  const _component_es_modal_header = _resolveComponent("es-modal-header")!
  const _component_es_modal_footer = _resolveComponent("es-modal-footer")!

  return (_ctx.isOpen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_es_modal_header, { header: _ctx.header }, null, 8, ["header"]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(t)('settings.label.accounting.financialGroup.financialChannel.data.title')), 1)
              ]),
              _createVNode(_unref(InputText), {
                type: "text",
                size: "small",
                modelValue: addOrUpdateFinancialChannelRequest.value.title,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((addOrUpdateFinancialChannelRequest.value.title) = $event)),
                class: "w-full"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(t)('settings.label.accounting.financialGroup.financialChannel.data.type')), 1)
              ]),
              _createVNode(_unref(Select), {
                modelValue: addOrUpdateFinancialChannelRequest.value.type,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((addOrUpdateFinancialChannelRequest.value.type) = $event)),
                options: channelTypes.value,
                size: "small",
                class: "w-full"
              }, _createSlots({
                option: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(_unref(t)(`settings.label.accounting.financialGroup.financialChannel.type.${slotProps.option}`)), 1)
                ]),
                _: 2
              }, [
                (addOrUpdateFinancialChannelRequest.value.type)
                  ? {
                      name: "value",
                      fn: _withCtx((slotProps) => [
                        _createTextVNode(_toDisplayString(_unref(t)(`settings.label.accounting.financialGroup.financialChannel.type.${slotProps.value}`)), 1)
                      ]),
                      key: "0"
                    }
                  : undefined
              ]), 1032, ["modelValue", "options"])
            ]),
            (_unref(FinancialChannelType).BankAccount === addOrUpdateFinancialChannelRequest.value.type)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(t)('settings.label.accounting.financialGroup.financialChannel.data.bank.bic')), 1)
                    ]),
                    _createVNode(_unref(InputText), {
                      type: "text",
                      size: "small",
                      modelValue: addOrUpdateFinancialChannelRequest.value.bankAccounts.bic,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((addOrUpdateFinancialChannelRequest.value.bankAccounts.bic) = $event)),
                      class: "w-full"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(t)('settings.label.accounting.financialGroup.financialChannel.data.bank.iban')), 1)
                    ]),
                    _createVNode(_unref(InputText), {
                      type: "text",
                      size: "small",
                      modelValue: addOrUpdateFinancialChannelRequest.value.bankAccounts.iban,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((addOrUpdateFinancialChannelRequest.value.bankAccounts.iban) = $event)),
                      class: "w-full"
                    }, null, 8, ["modelValue"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_es_modal_footer, {
            onModalCancel: closeFormModal,
            confirmModalMethod: () => confirmFormModal(),
            "confirm-disabled": confirmDisabled.value
          }, null, 8, ["confirmModalMethod", "confirm-disabled"])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})